// extracted by mini-css-extract-plugin
export default {"root":"regularPageContent_root__Ydo9g","stripes-animation-background-keyframes":"regularPageContent_stripes-animation-background-keyframes__5bK0d"};